import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { HOME, type Mode } from '../lib/context';
import { useSession } from './session';

/** Раздел доступен только в своём режиме; иначе — на главную текущего режима. */
export function RequireMode({ mode, children }: { mode: Mode; children: ReactNode }) {
  const s = useSession();
  if (s.mode !== mode) return <Navigate to={HOME[s.mode]} replace />;
  return <>{children}</>;
}

export function HomeRedirect() {
  const s = useSession();
  return <Navigate to={HOME[s.mode]} replace />;
}
